parseDocument